<button class="btn btn-link h-400 m-0" (click)="toggleFeedback()">Feedback</button>
@if (showFeedback()) {
  <app-customer-voice
    [displayInline]="false"
    (closed)="showFeedback.set(false)"
  ></app-customer-voice>
}
